import { RefsProvider } from "./refs-context"

interface AppProviderProps {
	children: React.ReactNode
}

export const AppProvider = ({ children }: AppProviderProps) => <RefsProvider>{children}</RefsProvider>
